import { useEffect, useState } from "react";
import api from "@/lib/api";

const fmtWhen = (iso) => {
  if (!iso) return "—";
  const d = new Date(iso);
  return d.toLocaleString("en-US", { month: "short", day: "numeric", hour: "numeric", minute: "2-digit" });
};

export const ActivityTab = () => {
  const [events, setEvents] = useState([]);
  const [staff, setStaff] = useState([]);
  const [roleFilter, setRoleFilter] = useState("all");

  useEffect(() => {
    api.get("/admin/activity").then((r) => setEvents(r.data)).catch(() => {});
    api.get("/admin/staff-activity").then((r) => setStaff(r.data)).catch(() => {});
  }, []);

  const visibleEvents = events.filter((e) => roleFilter === "all" || (e.role || "user") === roleFilter);

  return (
    <div className="mt-8 space-y-10" data-testid="activity-tab">
      <div>
        <h3 className="font-display text-lg font-bold text-ink">Staff changes</h3>
        <p className="mt-1 font-mono text-[10px] uppercase tracking-[0.15em] text-slate-400">
          which team member changed each booking, order, quote or promo
        </p>
        <div className="mt-4 overflow-x-auto rounded-2xl border border-slate-200 bg-white" data-testid="staff-activity-table">
          <table className="w-full min-w-[640px] text-left text-sm">
            <thead>
              <tr className="border-b border-slate-200 font-mono text-[10px] uppercase tracking-[0.18em] text-slate-500">
                <th className="px-5 py-4">When</th>
                <th className="px-5 py-4">Team member</th>
                <th className="px-5 py-4">Change</th>
                <th className="px-5 py-4">On</th>
                <th className="px-5 py-4">Detail</th>
              </tr>
            </thead>
            <tbody>
              {staff.length === 0 && (
                <tr><td colSpan={5} className="px-5 py-12 text-center text-slate-400">No staff changes recorded yet.</td></tr>
              )}
              {staff.map((e) => (
                <tr key={e.id} className="border-b border-slate-100 transition-colors duration-200 hover:bg-royal-light/40"
                    data-testid={`staff-row-${e.id}`}>
                  <td className="px-5 py-4 text-slate-600">{fmtWhen(e.at)}</td>
                  <td className="px-5 py-4">
                    <p className="font-semibold text-ink">{e.actor_name || "—"}</p>
                    <p className="text-xs text-slate-500">{e.actor_email}</p>
                  </td>
                  <td className="px-5 py-4 font-semibold text-ink">{e.action}</td>
                  <td className="px-5 py-4 font-mono text-xs text-royal">{e.target || "—"}</td>
                  <td className="px-5 py-4 text-xs text-slate-500">{e.detail || "—"}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>

      <div>
        <h3 className="font-display text-lg font-bold text-ink">Sign-ins</h3>
        <p className="mt-1 font-mono text-[10px] uppercase tracking-[0.15em] text-slate-400">
          every account sign-in, customer and team
        </p>
        <div className="mt-3 flex flex-wrap gap-2" data-testid="activity-filters">
          {[["all", "All"], ["admin", "Team"], ["user", "Customers"]].map(([key, label]) => (
            <button
              key={key}
              onClick={() => setRoleFilter(key)}
              data-testid={`activity-filter-${key}`}
              className={`rounded-full px-4 py-2 text-xs font-semibold transition-all duration-200 ${
                roleFilter === key ? "bg-ink text-white shadow-md" : "border border-slate-200 bg-white text-slate-500 hover:border-royal hover:text-royal"
              }`}
            >
              {label}
            </button>
          ))}
        </div>
        <div className="mt-4 overflow-x-auto rounded-2xl border border-slate-200 bg-white" data-testid="signin-activity-table">
          <table className="w-full min-w-[640px] text-left text-sm">
            <thead>
              <tr className="border-b border-slate-200 font-mono text-[10px] uppercase tracking-[0.18em] text-slate-500">
                <th className="px-5 py-4">When</th>
                <th className="px-5 py-4">Who</th>
                <th className="px-5 py-4">Role</th>
                <th className="px-5 py-4">Method</th>
              </tr>
            </thead>
            <tbody>
              {visibleEvents.length === 0 && (
                <tr><td colSpan={4} className="px-5 py-12 text-center text-slate-400">No sign-ins in this view.</td></tr>
              )}
              {visibleEvents.map((e, i) => (
                <tr key={`${e.user_id}-${e.at}-${i}`} className="border-b border-slate-100 transition-colors duration-200 hover:bg-royal-light/40"
                    data-testid={`activity-row-${i}`}>
                  <td className="px-5 py-4 text-slate-600">{fmtWhen(e.at)}</td>
                  <td className="px-5 py-4">
                    <p className="font-semibold text-ink">{e.name || "—"}</p>
                    <p className="text-xs text-slate-500">{e.email}</p>
                  </td>
                  <td className="px-5 py-4">
                    <span className={`rounded-full px-2.5 py-1 font-mono text-[10px] font-semibold uppercase tracking-[0.12em] ${e.role === "admin" ? "bg-royal-light text-royal" : "bg-slate-100 text-slate-500"}`}>
                      {e.role}
                    </span>
                  </td>
                  <td className="px-5 py-4 text-slate-600">{e.method === "google" ? "Google" : e.method === "company" ? "Company password" : "Password"}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};
